Monet.Format = Monet.Format || {};
Monet.Format.DATE = (function () {
  function DATE(value) {
    this.value = value;

    this.toGrid = function () {
      this.value = Monet.Format.Date.formatToLocale(this.value);
      return this;
    };

    this.getValue = function () {
      this.value = this.value || "";
      return this.value;
    };
  }

  return DATE;
})();

Monet.Format.Date = {
  // apply days, months, years or minutes offset to date
  applyOffset(date, { daysOffset, monthsOffset, yearsOffset, minutesOffset }) {
    date = daysOffset ? moment(date).add(daysOffset, 'day')._d : date;
    date = monthsOffset ? moment(date).add(monthsOffset, 'month')._d : date;
    date = yearsOffset ? moment(date).add(yearsOffset, 'year')._d : date;
    date = minutesOffset ? moment(date).add(minutesOffset, 'minute')._d : date;
    return date;
  },

  // returns a Date object with offset applied
  parse(inputDate, options = {}) {
    const pattern = options.pattern && options.pattern.replace('a', 'A');
    let date = moment(inputDate, pattern)._d;
    date = this.applyOffset(date, options);
    return date;
  },

  // returns a string corresponding to a date with a specific pattern and offset
  format(inputDate, options = {}) {
    if (!inputDate) {
      return '';
    }

    let pattern = (options.pattern || Monet.I18n.locale.dateFormat).replace('a', 'A');
    if (options.dayMonthOnly) {
      pattern = pattern.match(/(DD(\/|\.)MM|MM(\/|\.)DD)/gm)[0];
    }

    let date = this.parse(inputDate);
    date = this.applyOffset(date, options);

    
    if (options?.locale) {
      const momentInstance = new moment(date);

      return momentInstance.locale(options?.locale).format(pattern);
    }

    return moment(date).format(pattern);
  },

  // format date to user's locale
  formatToLocale(inputDate, options = {}) {
    if (Monet.I18n.locale.language === 'th') {
      options.yearsOffset = (options.yearOffset || 0) + 543;
    }
    if (Monet.I18n.locale.language === 'ar') {
      options.locale = "en";
    }
    return this.format(inputDate, options);
  },

  // parse date that was previously formatted to the user's locale
  parseLocale(inputDate, options = {}) {
    if (typeof inputDate === 'string') {
      options.pattern = options.pattern || Monet.I18n.locale.dateFormat;
    }
    if (Monet.I18n.locale.language === 'th') {
      options.yearsOffset = (options.yearOffset || 0) - 543;
    }
    return this.parse(inputDate, options);
  },

  parseLocaleToISOString(inputDate, options) {
    return inputDate ? this.formatToISOString(this.parseLocale(inputDate, options)) : '';
  },

  formatToISOString(inputDate, options = {}) {  
    return this.format(
      inputDate, 
      { 
        locale: 'en', 
        pattern: 'YYYY-MM-DD', 
        ...options 
      }
    );
  },

  getTodayISOString(options) {
    return this.format(
      moment()._d, 
      { 
        pattern: 'YYYY-MM-DD', 
        ...options 
      }
    );
  },

  getLocaleToday() {
    return Monet.I18n.locale.language === 'th' ? moment().add(543, 'year')._d : moment()._d;;
  },

  getFormattedLocaleToday(options) {
    return (this.formatToLocale(this.getTodayISOString(), options));
  }
};
